const Error404 = () => {
    return (
        <div className="flex min-h-[100dvh] flex-col items-center justify-center bg-background px-4 py-12 sm:px-6 lg:px-8">
            <img
                src="/images/logos/404sad.png"
                alt="Error image"
                width={200}
                height={200}
                className="mb-8"
            />
            <div className="mx-auto max-w-md text-center">
                <div className="mx-auto h-12 w-12 text-primary" />
                <h1 className="mt-4 text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
                    Oops, página no encontrada
                </h1>
                <p className="mt-4 text-muted-foreground">
                    Lo sentimos, pero la página que estás buscando no existe.
                    Por favor, intenta de nuevo o vuelve a la página de inicio.
                </p>
                <div className="mt-6">
                    <a
                        href={window.origin}
                        className="inline-flex items-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground shadow-sm transition-colors hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 bg-[#790546] text-white"
                    >
                        Ir a la página de inicio
                    </a>
                </div>
            </div>
        </div>
    );
};
export default Error404;
